import { axiosInstance } from '../api';


export default function (oldPassword, newPassword) {
    return axiosInstance.post('/api/auth/changePassword', {
        oldPassword,
        newPassword,
    });
}